import React from 'react'
import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@nominex/dex-uikit/dist/theme'
import { GlobalStyles as BaseStyles } from 'twin.macro'

declare module 'styled-components' {
  export interface DefaultTheme extends PancakeTheme {}
}

const CustomStyles = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.colors.gradients.spots};
    background-attachment: fixed;
    font-family: 'Inter', sans-serif;
    font-variant: common-ligatures tabular-nums;
    text-rendering: geometricPrecision;

    img {
      height: auto;
      max-width: 100%;
    }
  }

  svg {
    display: inline-block;
  }

  body.kayako-closed #kayako-messenger {
    display: none;
  }

  .sl-theme-dark sl-icon-button::part(base) {
    color: ${({ theme }) => theme.colors.darkGray100};
  }

  .sl-theme-dark sl-icon-button::part(base):hover,
  .sl-theme-dark sl-icon-button::part(base):focus {
    color: ${({ theme }) => theme.colors.white};
  }

  .sl-theme-dark sl-icon-button::part(base):active {
    color: ${({ theme }) => theme.colors.darkGray50};
  }

  /* sl-menu-item */
  .sl-theme-dark sl-menu-item::part(base),
  sl-menu-item:not([disabled]):hover::part(base) {
    color: ${({ theme }) => theme.colors.white};
  }

  input {
    outline: none;
    background-color: transparent;
    -moz-appearance: textfield;
    -webkit-appearance: textfield;

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  
    ::placeholder {
      color: ${({ theme }) => theme.colors.darkGray100};
      opacity: 0.6;
    }
    
    ::-webkit-search-decoration {
      -webkit-appearance: none;
    }
  }
`

const GlobalStyles = () => (
  <>
    <BaseStyles />
    <CustomStyles />
  </>
)

export default GlobalStyles
